import { render, staticRenderFns } from "./UsersLock.vue?vue&type=template&id=40b75980&"
import script from "./UsersLock.vue?vue&type=script&lang=js&"
export * from "./UsersLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports